import { ConfigClientModuleRepository } from '../domain/repositories/ConfigClientModuleRepository'
import { ConfigClientDatasource } from './ConfigClientDatasource'

export const configClientRepositoryAdapter = (
  configClient: ConfigClientDatasource
): ConfigClientModuleRepository => {
  return {
    async sleepConfig(patientId: string) {
      return await configClient.sleepConfig(patientId)
    },
    async updateSleepConfig(config) {
      return await configClient.updateSleepConfig(config)
    },
    async remedyConfig(patientId: string) {
      return await configClient.remedyConfig(patientId)
    },
    async photoConfig(config) {
      return await configClient.photoConfig(config)
    },
    async updatePhotoConfig(config) {
      return await configClient.updatePhotoConfig(config)
    },
    async updateRemedyConfig(config) {
      return await configClient.updateRemedyConfig(config)
    },
    async liquidConfig(patientId: string) {
      return await configClient.liquidConfig(patientId)
    },
    async updateLiquidConfig(config) {
      return await configClient.updateLiquidConfig(config)
    },
    async foodConfig(patientId: string) {
      return await configClient.foodConfig(patientId)
    },
    async updateFoodConfig(config) {
      return await configClient.updateFoodConfig(config)
    },
    async bathroomConfig(patientId: string) {
      return await configClient.bathroomConfig(patientId)
    },
    async updateBathroomConfig(config) {
      return await configClient.updateBathroomConfig(config)
    },
    async getAllModulesConfig(patientId: string) {
      return await configClient.getAllModulesConfig(patientId)
    }
  }
}
